/**
 * Entry module for the public docs site.
 *
 * Lives here, not in src/apps/docs/, because this directory is the Vite root
 * (see vite.config.docs.js). An entry referenced from index.html as
 * "../src/..." works in `vite build` but breaks in `vite dev` — the dev server
 * serves the path as written and the browser cannot resolve above the root, so
 * the module silently falls back to index.html and the page renders blank.
 * Keeping the entry inside the root makes the reference "/main.jsx" in both.
 *
 * The app itself stays in src/apps/docs/.
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import DocsApp from '@/apps/docs/DocsApp'
import '@/shared/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <DocsApp />
)
